type StoreId = number | string | null | undefined;

/**
 * Compares a cart's store id against a menu/catalog store id. `Store['id']` is
 * `number | string` while the v3 cart's is always `number`, so `===` mismatches.
 *
 * Numeric on both sides, so `'12.0'` and `12` agree. Store ids are numeric; a
 * non-numeric one compares `NaN === NaN` and is never the same store.
 *
 * Callers keep their own `!storeId` guards for the no-store case: the mapper's
 * `{ id: 0 }` sentinel must stay falsy at the call site, so this does not
 * special-case it.
 */
export const isSameStoreId = (a: StoreId, b: StoreId): boolean => {
  if (a == null || b == null) return false;

  return Number(a) === Number(b);
};
